import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Table, { TableRow, TableCell } from "@amzn/meridian/esm/components/table";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";
import { THEME_COLOR } from "../../../../styles/colors";

const StatusTable = ({ title, headers, rows, highlightRows }) => {
  const highlightSet = new Set(highlightRows || []);

  return (
    <Theme tokens={{ boxBorderColorOutline: THEME_COLOR.MIST_GRAY, boxBorderRadiusOutline: 12 }}>
      <Box type="outline" spacingInset="400">
        <Column spacing="300">
          {title && <Text type="h100">{title}</Text>}
          <Table headerRows={Array.isArray(headers) && headers.length > 0 ? 1 : 0} spacing="small" showStripes showDividers>
            {Array.isArray(headers) && headers.length > 0 && (
              <TableRow highlightOnHover>
                {headers.map((header, i) => (
                  <TableCell key={i}>{header}</TableCell>
                ))}
              </TableRow>
            )}
            {Array.isArray(rows) && rows.map((row, rowIdx) => (
              <TableRow key={rowIdx} highlightOnHover backgroundColor={highlightSet.has(rowIdx) ? "subdued" : undefined}>
                {Array.isArray(row) && row.map((cell, cellIdx) => (
                  <TableCell key={cellIdx}>{cell}</TableCell>
                ))}
              </TableRow>
            ))}
          </Table>
        </Column>
      </Box>
    </Theme>
  );
};

export default StatusTable;
